module.exports = __webpack_public_path__ + "section/footer/img/logo.png?hash=2524197a7794a6bc1d1aa521de53f55a"


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/asset-loader!./LeLab.LogAlto.Web/src/modules/section/footer/img/logo.png
 ** module id = 84
 ** module chunks = 0 1
 **/